import React, { useContext, useEffect } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import HomeViewTecnico from "../../Styles/layout/homeViewTecnico";
import EuroOutlinedIcon from "@mui/icons-material/EuroOutlined";
import WarehouseIcon from '@mui/icons-material/Warehouse';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import LandscapeIcon from '@mui/icons-material/Landscape';
import GroupsIcon from '@mui/icons-material/Groups';
import { useLocation, useNavigate } from "react-router-dom";
import { func_print } from "../../Func_genericas/func_print";
import { get } from "../../Services/tokenConfig";
import { AuthContext } from "../../AuthContext/AuthContext";
import Badge from '@mui/material/Badge';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: { display: "flex" },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
  })
);

const cards = [
  { id: "armazem", label: <><br />Armazéns</>, link: "/armazem", icon: <WarehouseIcon sx={{ fontSize: 48 }} /> },
  { id: "mao-obra", label: <><br />Mão de Obra</>, link: "/maoobra", icon: <GroupsIcon sx={{ fontSize: 48 }} /> },
  { id: "equipamentos", label: <><br />Equipamentos</>, link: "/equipamentos", icon: <AgricultureIcon sx={{ fontSize: 48 }} /> },
  { id: "financeiro", label: <><br />Financeiro</>, link: "/financeiro", icon: <EuroOutlinedIcon sx={{ fontSize: 48 }} /> },
  { id: "atividades", label: <>Atividades<br />de Campo</>, link: "/atividades", icon: <LandscapeIcon sx={{ fontSize: 48 }} /> },
];

function PortalAgricultor() {
  const auth = useContext(AuthContext);
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const id_agri: number | undefined = location.state as number | undefined;

  const [notificacao_mao_obra, set_notificacao_mao_obra] = React.useState<any>();
  const [notificacao_equipamentos, set_notificacao_equipamentos] = React.useState<any>();

  const handler_mudar_screen = (link: string) => {
    if (id_agri != null) {
      navigate(link, { state: id_agri });
    } else {
      navigate(link);
    }
  };

  const get_info = async () => {
    try {
      func_print('auth.token.cookie_token get_info', auth.token.cookie_token)

      let res_mao_obra = await get(auth.token.cookie_token,
        `/api/trabalhadores/documentos/expirar/${id_agri}`
      );
      let res_equipamentos = await get(auth.token.cookie_token,
        `/api/maquinas/alertas/${id_agri}`
      );

      if (res_mao_obra.status === 200) {
        set_notificacao_mao_obra(res_mao_obra.data.result.length);
      }
      if (res_equipamentos.status === 200) {
        set_notificacao_equipamentos(res_equipamentos.data.result.total_alertas);
      }

    } catch (error) {
      func_print("get_info", error, true);
    }
  }


  useEffect(() => {
    (async () => {
      await get_info();
    })();
  }, [])

  return (
    <div className={classes.root}>
      <HomeViewTecnico title="Portal do Agricultor" />
      <main className={classes.contents}>
        <div className={classes.toolbars} />

        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10 p-4">
          {cards.map((card) => {
            if (card.id === 'mao-obra' && notificacao_mao_obra > 0) {
              return (
                <div
                  key={card.id}
                  className="rounded-xl cursor-pointer shadow-sm hover:shadow-md p-5 flex flex-col gap-3 text-[#353C47] overflow-hidden relative  bg-[linear-gradient(60deg,white_80%,#750000_70%)] transition-all duration-200 hover:scale-[1.02] "
                  onClick={() => handler_mudar_screen(card.link)}
                >

                  <div className="text-[#c94f1e]">
                    <Badge badgeContent={notificacao_mao_obra} color="error">
                      {card.icon}
                    </Badge></div>
                  <div>
                    <p className="text-xl font-medium text-gray-500 m-0">{card.label}</p>
                  </div>
                </div>

              )

            } else if (card.id === 'equipamentos' && notificacao_equipamentos > 0) {
              return (
                <div
                  key={card.id}
                  className="rounded-xl cursor-pointer shadow-sm hover:shadow-md p-5 flex flex-col gap-3 text-[#353C47] overflow-hidden relative  bg-[linear-gradient(60deg,white_80%,#750000_70%)] transition-all duration-200 hover:scale-[1.02] "
                  onClick={() => handler_mudar_screen(card.link)}
                >
                  <div className="text-[#c94f1e]"><Badge badgeContent={notificacao_equipamentos} color="error">
                    {card.icon}
                  </Badge></div>
                  <div>
                    <p className="text-xl font-medium text-gray-500 m-0">{card.label}</p>
                  </div>
                </div>

              )
            } else {
              return (
                <div
                  key={card.id}
                  className="rounded-xl cursor-pointer shadow-sm hover:shadow-md p-5 flex flex-col gap-3 text-[#353C47] overflow-hidden relative  bg-[linear-gradient(60deg,white_80%,#c94f1e_70%)] transition-all duration-200 hover:scale-[1.02] "
                  onClick={() => handler_mudar_screen(card.link)}
                >
                  <div className="text-[#c94f1e]">{card.icon}</div>
                  <div>
                    <p className="text-xl font-medium text-gray-500 m-0">{card.label}</p>
                  </div>

                </div>

              )
            }


          })}
        </div>
      </main>
    </div>
  );
}

export default PortalAgricultor;
